import browser from "webextension-polyfill";
import { setupDetection } from "../content/detection";
import { executeFunction } from "./script-injector";
export async function injectDetectionScript(details) {
    const { tabId, frameId } = details;
    if (details.frameId !== 0) {
        return;
    }
    try {
        await executeFunction(tabId, frameId, setupDetection);
    }
    catch (_) {
    }
}
export function navigationListener(details) {
    void injectDetectionScript(details);
}
export function start() {
    browser.webNavigation.onCommitted.addListener(navigationListener);
}
